import { mixed, object, string } from 'yup';

export const supportFormSchema = object({
    name: string().required('Name is a required field'),
    email: string().email().required('E-mail is a required field'),
    subject: string(),
    siteUrl: string(),
    theme: string()
        .matches(/^(?!default$).*/, 'Please, select a theme')
        .required('Please, select a theme'),
    request: string().required('Request is a required field'),
    files: mixed(),
});
